<ng-container *ngTemplateOutlet="mode() === 'home' ? homefilter : nohomefilter"></ng-container>

<ng-template #homefilter>
    <ng-container [ngSwitch]="media">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="homefilterdesk"></ng-container>
    </ng-container>
</ng-template>

<ng-template #homefilterdesk>
    <button class="tmpbtn w100 tmp-left tmpnorightborder" #mdbuttondesk="cdkOverlayOrigin" cdkOverlayOrigin
        (click)="openModal($event)" matRipple>
        <!-- <mat-icon fontIcon="location_on"></mat-icon> -->
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
            <path d="M0 0h24v24H0z" fill="none" />
            <path
                d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
        </svg>
        <span multilang class="ellipsis w85">{{zielText }}</span>
    </button>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttondesk"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="closeModal()">
        <ng-container *ngTemplateOutlet="modal"></ng-container>
    </ng-template>
</ng-template>

<ng-template #homemodeMobile>
    <button class=" w100  tmp-top" #mdbuttonMobile="cdkOverlayOrigin" cdkOverlayOrigin (click)="openModalMobile($event)"
        matRipple>
        <!-- <mat-icon fontIcon="location_on"></mat-icon> -->
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
            <path d="M0 0h24v24H0z" fill="none" />
            <path
                d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
        </svg>
        <span multilang class="ellipsis w85">{{zielText }}</span>
    </button>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttonMobile"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="closeModalMobile()">
        <ng-container *ngTemplateOutlet="modal"></ng-container>
    </ng-template>
</ng-template>

<ng-template #nohomefilter>
    <ng-container *ngIf="mode() === 'nohomesmall' else mbfilters">
        {{suffix }} {{zielText !== 'Reiseziel oder Hotelname' ? (zielText ) : '' }}
    </ng-container>
</ng-template>
<ng-template #mbfilters>
    <button class="tmpbtn w100 tmpnobottomborder" #mdbuttonMobile="cdkOverlayOrigin" cdkOverlayOrigin
        (click)="openModalMobile($event)" matRipple>
        <!-- <mat-icon fontIcon="location_on"></mat-icon> -->
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
            <path d="M0 0h24v24H0z" fill="none" />
            <path
                d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
        </svg>
        <span multilang class="ellipsis w85">{{zielText }}</span>
    </button>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttonMobile"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="closeModalMobile()">
        <ng-container *ngTemplateOutlet="modal"></ng-container>
    </ng-template>
</ng-template>

<ng-template #modal>
    <ng-container [ngSwitch]="media">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="mobileModal"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="mobileModal"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="mobileDesk"></ng-container>
    </ng-container>
</ng-template>

<ng-template #mobileDesk>
    <div class="backdropwrapper mat-elevation-z1" [@zoom]="origin">
        <div class="filterwrapper">
            <div class="f-headerwrapper">
                <input type="text" multilang deeplMode='placeholder' placeholder="{{'Wohin' }}?"
                    (paste)="detectPast($event)" [formControl]="mySearchControl" ng-focus [appAutoFocus]="focus"
                    class="searchinput">
                <button matRipple (click)="clearText()" *ngIf="mySearchControl?.value?.length > 0">
                    <mat-icon class="btnico">clear</mat-icon>
                </button>
            </div>
            <ng-container *ngTemplateOutlet="datassection"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #mobileModal>
    <div class="backdropwrapper-mobile" [@zoom]="origin">
        <div class="filterwrapper-mobile">
            <div class="f-headerwrapper">
                <button matRipple (click)="closeModalMobile()">
                    <mat-icon class="btnico-mobile">arrow_back</mat-icon>
                </button>
                <input type="text" multilang deeplMode='placeholder' placeholder="{{'Wohin' }}?"
                    (paste)="detectPast($event)" [formControl]="mySearchControl" ng-focus [appAutoFocus]="focus"
                    class="searchinput">
            </div>
            <ng-container *ngTemplateOutlet="datassection"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #datassection>
    <div class="f-bodywrapper customscroll">
        <ng-container *ngIf="mySearchControl?.value?.length > 0 else defaultDatas">
            <ng-container *ngFor="let item of (searchObj | async)">
                <ng-container [ngSwitch]="item.type">
                    <ng-container *ngSwitchCase="1">
                        <ng-container *ngTemplateOutlet="hotel context:{item:item}"></ng-container>
                    </ng-container>
                    <ng-container *ngSwitchCase="2">
                        <ng-container *ngTemplateOutlet="ort context:{item:item}"></ng-container>
                    </ng-container>
                    <ng-container *ngSwitchCase="3">
                        <ng-container *ngTemplateOutlet="region context:{item:item}"></ng-container>
                    </ng-container>
                    <ng-container *ngSwitchCase="4">
                        <ng-container *ngTemplateOutlet="land context:{item:item}"></ng-container>
                    </ng-container>
                </ng-container>
            </ng-container>
        </ng-container>
    </div>
</ng-template>


<ng-template #defaultDatas>
    <ng-container *ngIf="type() !== 'railtravel' else bahnver">
        @if(completion()?.length > 0) {
        <ng-container *ngTemplateOutlet="completionextra"></ng-container>
        } @else {
        <span multilang class="tt-text">{{'AKTUELL BELIEBT' }}</span>
        <ng-container *ngFor="let item of defaultdatas">
            <ng-container [ngSwitch]="item.type">
                <ng-container *ngSwitchCase="1">
                    <ng-container *ngTemplateOutlet="hotel context:{item:item}"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="2">
                    <ng-container *ngTemplateOutlet="ort context:{item:item}"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="3">
                    <ng-container *ngTemplateOutlet="region context:{item:item}"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="4">
                    <ng-container *ngTemplateOutlet="land context:{item:item}"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="-1">
                    <ng-container *ngTemplateOutlet="egal context:{item:item}"></ng-container>
                </ng-container>
            </ng-container>
        </ng-container>
        }
    </ng-container>
    <ng-template #bahnver>
        <span multilang class="tt-text">{{'AKTUELL BELIEBT' }}</span>
        <ng-container *ngFor="let item of defaultdatasBahn">
            <ng-container [ngSwitch]="item.type">
                <ng-container *ngSwitchCase="1">
                    <ng-container *ngTemplateOutlet="hotel context:{item:item}"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="2">
                    <ng-container *ngTemplateOutlet="ort context:{item:item}"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="3">
                    <ng-container *ngTemplateOutlet="region context:{item:item}"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="4">
                    <ng-container *ngTemplateOutlet="land context:{item:item}"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="-1">
                    <ng-container *ngTemplateOutlet="egal context:{item:item}"></ng-container>
                </ng-container>
            </ng-container>
        </ng-container>
    </ng-template>
</ng-template>

<ng-template #egal let-item="item">
    <button class="item-wrapper" (click)="selectValue(item)">
        <mat-icon class="egal-ico">mode_of_travel</mat-icon>
        <ng-template #icon>
            <!-- <mat-icon  class="item-icon">push_pin</mat-icon> -->
            <svg class="item-icon" xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px"
                viewBox="0 0 24 24" width="24px" fill="#000000">
                <g>
                    <rect fill="none" height="24" width="24" />
                </g>
                <g>
                    <path
                        d="M16,9V4l1,0c0.55,0,1-0.45,1-1v0c0-0.55-0.45-1-1-1H7C6.45,2,6,2.45,6,3v0 c0,0.55,0.45,1,1,1l1,0v5c0,1.66-1.34,3-3,3h0v2h5.97v7l1,1l1-1v-7H19v-2h0C17.34,12,16,10.66,16,9z"
                        fill-rule="evenodd" />
                </g>
            </svg>
        </ng-template>
        <div class="item-body">
            <span multilang class="first-item-line">{{item.name }}</span>
        </div>
    </button>
</ng-template>

<ng-template #land let-item="item">
    <button class="item-wrapper" (click)="selectValue(item)">
        <ng-container *ngIf="item?.img?.length > 0 else icon">
            <img class="lazyload" width="40px" height="40px" src="{{item.img}}">
        </ng-container>
        <ng-template #icon>
            <!-- <mat-icon  class="item-icon">push_pin</mat-icon> -->
            <svg class="item-icon" xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px"
                viewBox="0 0 24 24" width="24px" fill="#000000">
                <g>
                    <rect fill="none" height="24" width="24" />
                </g>
                <g>
                    <path
                        d="M16,9V4l1,0c0.55,0,1-0.45,1-1v0c0-0.55-0.45-1-1-1H7C6.45,2,6,2.45,6,3v0 c0,0.55,0.45,1,1,1l1,0v5c0,1.66-1.34,3-3,3h0v2h5.97v7l1,1l1-1v-7H19v-2h0C17.34,12,16,10.66,16,9z"
                        fill-rule="evenodd" />
                </g>
            </svg>
        </ng-template>
        <div class="item-body">
            <span multilang class="first-item-line">{{item.name }}</span>
            <small class="second-item-line">{{'Land' }}</small>
        </div>
    </button>
</ng-template>

<ng-template #region let-item="item">
    <button class="item-wrapper" (click)="selectValue(item)">
        <ng-container *ngIf="item?.img?.length > 0 else icon">
            <img class="lazyload" width="40px" height="40px" src="{{item.img}}">
        </ng-container>
        <ng-template #icon>
            <!-- <mat-icon  class="item-icon">location_on</mat-icon> -->
            <svg class="item-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
                fill="#000000">
                <path d="M0 0h24v24H0z" fill="none" />
                <path
                    d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
            </svg>
        </ng-template>
        <div class="item-body">
            <span multilang class="first-item-line">{{item.name }}</span>
            <small class="second-item-line">{{item?.superRegion?.name?.length > 0 ? ('Region in ' ) : ('Region ' )}}
                {{item?.superRegion?.name }}</small>
        </div>
    </button>
</ng-template>

<ng-template #ort let-item="item">
    <button class="item-wrapper" (click)="selectValue(item)">
        <ng-container *ngIf="item?.img?.length > 0 else icon">
            <img class="lazyload" width="40px" height="40px" src="{{item.img}}">
        </ng-container>
        <ng-template #icon>
            <!-- <mat-icon  class="item-icon">location_city</mat-icon> -->
            <svg class="item-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
                fill="#000000">
                <path d="M0 0h24v24H0z" fill="none" />
                <path
                    d="M15 11V5l-3-3-3 3v2H3v14h18V11h-6zm-8 8H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm6 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm6 12h-2v-2h2v2zm0-4h-2v-2h2v2z" />
            </svg>
        </ng-template>
        <div class="item-body">
            <span multilang class="first-item-line">{{item.name }}</span>
            <small class="second-item-line">{{item?.region?.name?.length > 0 ? ('Ort in ' ) : ('Ort ' )}}
                {{item?.region?.name }}</small>
        </div>
    </button>
</ng-template>

<ng-template #hotel let-item="item">
    <button class="item-wrapper" (click)="selectValue(item)">
        <ng-container *ngIf="item?.img?.length > 0 else icon">
            <img class="lazyload" width="40px" height="40px" src="{{item.img}}">
        </ng-container>
        <ng-template #icon>
            <!-- <mat-icon  class="item-icon">apartment</mat-icon> -->
            <svg class="item-icon" xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px"
                viewBox="0 0 24 24" width="24px" fill="#000000">
                <g>
                    <rect fill="none" height="24" width="24" />
                </g>
                <g>
                    <path
                        d="M17,11V3H7v4H3v14h8v-4h2v4h8V11H17z M7,19H5v-2h2V19z M7,15H5v-2h2V15z M7,11H5V9h2V11z M11,15H9v-2h2V15z M11,11H9V9h2 V11z M11,7H9V5h2V7z M15,15h-2v-2h2V15z M15,11h-2V9h2V11z M15,7h-2V5h2V7z M19,19h-2v-2h2V19z M19,15h-2v-2h2V15z" />
                </g>
            </svg>
        </ng-template>
        <div class="item-body">
            <span multilang class="first-item-line">{{item.name }}</span>
            <small class="second-item-line">{{item?.region?.name?.length > 0 ? ('Hotel in ' ) : ('Hotel ' )}}
                {{item?.region?.name }}</small>
        </div>
    </button>
</ng-template>

<ng-template #completionextra>
    <div class="zwrp customscroll">
        @for (item of completion(); let j = $index; track item) {
        <div class="zcc2">
            <div class="zcc3">
                <span multilang class="tt-text_extra">{{item.title}}</span>
            </div>
            @for (obj of item?.objects; let k = $index; track obj) {
            <button class="zcc5" (click)="setSelection(obj)">
                <app-ziel [item]="obj"></app-ziel>
            </button>
            }
        </div>
        }
    </div>
</ng-template>